export const BASE_URL = 'https://api.aurorabirth.com'
